<template>
    <div class="sq-index">
        <div v-if="!isWeixin" class="sq-notice">
            <div class="weui-msg">
                <div class="weui-msg__icon-area">
                    <i class="el-icon-warning" style="color: #2b94ff;font-size:100px">
                    </i>
                </div>
                <div class="weui-msg__text-area">
                    <h2 class="weui-msg__title">温馨提示</h2>
                    <p class="weui_msg__desc">{{notice}}</p>
                </div>
            </div>
        </div>
        <div v-else>
        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                notice: '请在微信客户端打开链接!',
                isWeixin: false,
                appId: '',
                deptId: '',
                empId:'',
            };
        },

        async created() {
            document.title = "授权"
            this.deptId=this.$route.params.did
            this.empId=this.$route.params.empId
            await this.panduan()
            if (this.isWeixin) {
                await this.getSpmGzh()
                await this.getCode()
            }
        },
        methods: {
            panduan() {
                let that = this;
                var ua = navigator.userAgent.toLowerCase(); //判断是否是微信浏览器
                var isWeixin = ua.indexOf("micromessenger") != -1; //判断是否
                this.isWeixin = isWeixin
                if (!isWeixin) {
                    return false;
                }
            },

            async getSpmGzh() {
                let res = await this.$get("/spm/getSpmGzh", {deptId: this.deptId})
                this.appId = res.gzhInfo.appid
            },
            getCode() { // 非静默授权，第一次有弹框
                const code = this.getUrlParam("code"); // 截取路径中的code
                this.code = code
                if (this.code == null || this.code === '') { // 如果没有code，则去请求
                    var local = window.location.href // 获取页面url
                    var appid = this.appId
                    const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&state=123&connect_redirect=1#wechat_redirect`
                    window.location.href = url
                } else {
                    this.updateEmp(this.code)
                }
            },

            async updateEmp(code) {
                let data = {
                    code: code,
                    deptId: this.deptId,
                    empId: this.empId,
                }
                let res = await this.$post("/spm/updateEmp", data)
                if (res.code == 200) {
                 window.location.href = 'https://wx.fanboshi.net/#/sqcg/' + this.deptId
                } else {
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: 'red'
                    });
                }
            },
            // 编码函数
            getUrlParam(name) {
                var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
                var r = window.location.search.substr(1).match(reg); //匹配目标参数
                if (r != null) return unescape(r[2]);
                return null; //返回参数值
            },
        },
    };
</script>

<style lang="scss" scoped>
    .sq-index {
        overflow: hidden;
    }

    .sq-notice {
        margin: auto;
        font-size: 18px;
        text-align: center;
        margin-top: 23%;
    }

    .weui-msg {
        padding-top: 36px;
        text-align: center;
    }

    .weui-msg__icon-area {
        margin-bottom: 30px;
    }

    .weui-icon_msg {
        font-size: 93px;
    }

    .weui-icon-info {
        font-size: 23px;
        color: #10aeff;
    }

    .weui-msg__text-area {
        margin-bottom: 25px;
        padding: 0 20px;
    }

    .weui-msg__title {
        margin-bottom: 5px;
        font-weight: 400;
        font-size: 20px;
    }

    .weui_msg__desc {
        margin-top: 16px;
    }


</style>
